import notAuthorized from "../../Assests/403.svg";
import Button from "../../components/GButton/Button";


export default function NotAuthorized () {

    return (
        <div className="flex flex-col justify-center items-center sm:mt-5 mt-14 p-10 gap-10">
            <div className="sm:w-[70%] w-full">
                <img src={notAuthorized} alt="not-authorized"/>
            </div>
            <div>
                <h1 className="text-[20px] sm:text-[25px] font-bold">
                    ليس لديك صلاحيات للوصول
                </h1>
            </div>
            <div>
                <Button background="#EBAC32" borderRadius="8px" color="white" padding="12px" text=" تسجيل الدخول" nav={"/login"} />
            </div>
        </div>
    )
}